export default __webpack_public_path__ + "static/media/img_3.515da347.jpg";